import "@frog/source/views/components/DialogueBox.less"
import * as Preact from "preact"
import unitsprites from "@frog/source/data/unitsprites.js"

export default class DialogueBox {
    render() {
        return (
            <div class="Dialogue" modal={this.props.stage?.flags?.modal}>
                {this.scene}
                <div class="Boxes">
                    {this.box}
                    {this.props.children}
                </div>
            </div>
        )
    }
    get box() {
        const dialogue = this.props.dialogue || this.props.stage.dialogue
        if(dialogue == undefined) return

        return (
            <div class="Box">
                {this.name}
                {this.words}
            </div>
        )
    }
    get words() {
        const dialogue = this.props.dialogue || this.props.stage.dialogue
        if(dialogue.text == undefined) return
        let words = dialogue.text
        // words = words.replace("<i>", "").replace("</i>", "")
        // if(dialogue.index != undefined) {
        //     words = words.substring(0, dialogue.index)
        // }
        // {words.split("<br>").filter((text) => text != "").map((subwords) => {
        //     return (
        //         <div class="TextLine">{subwords}</div>
        //     )
        // })}
        const letters = words.split("")
        let isItalicized = false
        let isBolded = false
        return (
            <div class="Words">
                {letters.map((character, index) => {
                    if(character == "*") {
                        if(letters[index+1] == "*") {
                            isBolded = !isBolded
                        } else {
                            if(letters[index-1] != "*") {
                                isItalicized = !isItalicized
                            }
                        }
                        return
                    }
                    if(character == "_") {
                        if(letters[index+1] == "_") {
                            isBolded = !isBolded
                        } else {
                            if(letters[index-1] != "_") {
                                isItalicized = !isItalicized
                            }
                        }
                        return
                    }
                    if(character == '\n') {
                        return <br/>
                    }
                    if(isBolded == true) {
                        character = character.toUpperCase()
                    }
                    return (
                        <div class="Character" style={{
                                "opacity": index <= (dialogue.index ?? dialogue.text.length) ? 1 : 0,
                                "font-weight": isBolded ? "bold" : "normal",
                                "font-style": isItalicized ? "italic" : "initial",
                            }}>
                            {character}
                        </div>
                    )
                })}
            </div>
        )
    }
    get name() {
        const dialogue = this.props.dialogue || this.props.stage.dialogue

        if(dialogue.data?.speakerName != undefined) {
            return (
                <div class="Name">
                    <div class="Bolder Text">{dialogue.data.speakerName}</div>
                </div>
            )
        }

        const unit = this.props.stage.units[dialogue.data?.speakerKey]

        if(dialogue.data?.speakerKey != undefined
        && unit != undefined) {
            return (
                <div class="Name">
                    <div class="Bolder Text">{unit.title || unit.name}</div>
                </div>
            )
        }
    }
    get scene() {
        const dialogue = this.props.dialogue || this.props.stage.dialogue

        const scene = dialogue?.data?.scene
        if(scene == undefined) return
        if(scene.units == undefined) return

        return (
            <div class="Scene">
                {Object.values(scene.units).map((unit) => {
                    if(this.props.stage.units[unit.key] == undefined) return

                    const isSpeaking = unit.key == dialogue.data.speakerKey
                    const direction = unit.direction || "right"
                    const position = unit.position || "1"
                    const expression = unit.expression || "neutral"
                    const flourish = unit.flourish || "shift"

                    let image = undefined
                    if(this.props.stage.units[unit.key].portraitKey != undefined
                    && unitsprites.portraits[this.props.stage.units[unit.key].portraitKey] != undefined) {
                        image = unitsprites.portraits[this.props.stage.units[unit.key].portraitKey]
                    }
                    if(this.props.stage.units[unit.key].portraits != undefined
                    && this.props.stage.units[unit.key].portraits[expression] != undefined) {
                        image = this.props.stage.units[unit.key].portraits[expression]
                    }
                    if(image == undefined) {
                        // console.error("a dialogue portrait was specified but the image is not found")
                        // defaulting to showing nothing
                        return
                    }

                    return (
                        <img class="Portrait" key={unit.key} src={image}
                            isSpeaking={isSpeaking}
                            direction={direction} position={position}
                            expression={expression} flourish={flourish}/>
                    )
                })}
            </div>
        )
    }
}
